import type { Account } from '@openx/types/account.ts';
import { QueryKeys } from '@openx/utils/api/queryKeys.ts';
import { fetchApiResponseHandler } from '@openx/utils/api/utils.ts';
import { useQuery } from '@tanstack/react-query';
import axios from 'axios';
import { useTranslation } from 'react-i18next';

export const useAccountFetch = (accountUid?: string) => {
  const { t } = useTranslation();

  const {
    isLoading: isAccountLoading,
    data: account,
    refetch,
  } = useQuery<Account>({
    enabled: !!accountUid,
    meta: {
      errorMessage: t('Failed to fetch Account.'),
    },
    queryFn: () => fetchApiResponseHandler<Account>(axios.get(`/account/${accountUid}`), undefined, true),
    queryKey: [QueryKeys.ACCOUNT, accountUid],
    retry: false,
  });

  return {
    account: account || null,
    isAccountLoading,
    refetch,
  };
};
